var BOLD = BOLD || {};
BOLD.BMS = BOLD.BMS || {};
BOLD.BMS.Analytics = BOLD.BMS.Analytics || {};

BOLD.BMS.Analytics.Google = function($) {

    this.product = null;

    this.config = {
        isInit: false,
        available: true,
        setTracking: false
    }

    this.settings = {
        maxRetry: 10
    };

    function init(data, options){
        if(!config.isInit) {
            settings = $.extend(settings, options);
            config.isInit = true;
            product = data || {};

            // Set Tracking (can also be handled on page/settings)
            if (config.setTracking) Tracking.set();

            // Bind events
            bind();
        }
    }

    function bind(){
        // Product
        $(".product-sidebar").on("mouseup", ".bold-ro__one-time-div,.bold-ro__recurring-div,.one_time_div,.recurring_div", function(event) {
            let $this = $(this);
            let isSelected = $this.find("input:radio").first().val() != 0;

            // Workaround due to native code being overriten and events being fired twice
            if(config.available)
            {
                config.available = false;
                timeout = setTimeout(function(){ config.available = true; }, 500);
                let tracking = Tracking.create($this.closest(".product"), isSelected);

                Tracking.send(tracking);
            }
        });
        
        // Regular Cart
        $(".line-item.has-ro").on("change", "input:checkbox[id^=subscribe]", function() {
            let $this = $(this);
            let isSelected = $(this).is(":checked");
            
            let tracking = Tracking.create("cart", $this.closest(".line-item.has-ro"), isSelected);

            Tracking.send(tracking);
        });
    }

    let Tracking = function() {
        this.retry = 0;

        function set() {
            // Get Dimension value
            let dimensionValue = "page-" + getPage(window.location.pathname);

            // Call ga
            let success = execGA('set', 'dimension4', dimensionValue);

            // If operation wasn't successful, retry every 1 second or until reaches max retry
            if(!success && this.retry < settings.maxRetry){
                console.log("Retrying...");
                window.setTimeout(() => {
                    this.retry++;
                    set();
                }, 1000);
            } else {
                this.retry = 0;
            }
        }

        function create($info, isChecked) {
            let page = getPage(window.location.pathname);
            let label = product.handle ? page + ":" + product.handle : page;
            let obj = {};

            obj.category = "Ro-Optin/out";
            obj.action = isChecked ? "Opt In" : "Opt Out";
            obj.label = label;
            
            return obj;
        }
        
        function send(tracking) {
            if(!BOLD.DebugMode){
                execGA('send', 'event', {
                    eventCategory: tracking.category,
                    eventAction: tracking.action,
                    eventLabel: tracking.label,
                    transport: 'beacon'
                });
            } else {
                console.log(tracking);
            }
        }
        
        function execGA(command, fields, object){
            let success = false;
            try {
                ga(command, fields, object);
                success = true;
            } catch {
                console.log("Google Analytics not found. Command '" + command + "' for '" + fields + "' not registered.");
            }
            return success;
        }

        return {
            set: set,
            create: create,
            send: send
        }
    }();

    function getProductsHandle() {
        let result = getHandle("products", document.referrer);
        return result ? result[1] : "";
    }

    function getHandle(text, url) {
        let regex = new RegExp(`.*\/${text}\/([^?]*)`);
        return regex.exec(url);
    }

    function getPage(url) {
        let regex = new RegExp(`\/([^?\/]*)\/?`);
        let page = regex.exec(url);
        return page && page[1] ? page[1] : "homepage";
    }

    return {
        init: init
    }

}(BOLD.jQuery || jQuery)